import axios from 'axios'
import { api } from '../api'
import mock from '../mocks/agents-list'

/**
 * Constants
 * */
export const moduleName = 'agents'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const CLOSE = '_CLOSE'

export const AGENTS = `${moduleName}/AGENTS`
export const AGENTS_DELETE = `${moduleName}/AGENTS_DELETE`
export const AGENTS_ADD_BLACKLIST = `${moduleName}/AGENTS_ADD_BLACKLIST`
export const AGENTS_DELETE_BLACKLIST = `${moduleName}/AGENTS_DELETE_BLACKLIST`
export const AGENTS_CHANGE_ACCESS = `${moduleName}/AGENTS_CHANGE_ACCESS`

export const ERRORMSG = `${moduleName}/ERRORMSG`

export const RESET = `${moduleName}/RESET`

/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    response: null,
    action: false
}

export default (state = defaultState, action) => {
    const { type, error, response } = action

    switch (type) {
        case AGENTS + START:
            return { 
                ...state, 
                loading: true 
        }
        case AGENTS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                action: false,
                response: response
        }
        case AGENTS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case AGENTS_DELETE + START:
            return { 
                ...state, 
                loading: true 
        }
        case AGENTS_DELETE + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                action: true
        }
        case AGENTS_DELETE + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case AGENTS_ADD_BLACKLIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case AGENTS_ADD_BLACKLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                action: true
        }
        case AGENTS_ADD_BLACKLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case AGENTS_DELETE_BLACKLIST + START:
            return { 
                ...state, 
                loading: true 
        }
        case AGENTS_DELETE_BLACKLIST + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                action: true
        }
        case AGENTS_DELETE_BLACKLIST + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case AGENTS_CHANGE_ACCESS + START:
            return { 
                ...state, 
                loading: true 
        }
        case AGENTS_CHANGE_ACCESS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                action: true
        }
        case AGENTS_CHANGE_ACCESS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        case ERRORMSG + CLOSE:
            return {
                ...state,
                error: null
            }
            
        case RESET: 
            return defaultState

        default:
            return state
    }
}

/**
 * Action Creators
 * */
export const loadAgentsList = (params) => async (dispatch) => {

    //return dispatch({ type: AGENTS + SUCCESS, response: mock })
    
	dispatch({ type: AGENTS + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data)

		if (data.success) {
            dispatch({ 
                type: AGENTS + SUCCESS, 
                response: data.content.ShortInfo
            })
        }
        if (data.error) {
            dispatch({ 
                type: AGENTS + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const deleteAgent = (params) => async (dispatch) => {

	dispatch({ type: AGENTS_DELETE + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data)

		if (data.success) {
            dispatch({ type: AGENTS_DELETE + SUCCESS })
        }
        if (data.error) {
            dispatch({ 
                type: AGENTS_DELETE + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const addAgentBlackList = (params) => async (dispatch) => {

	dispatch({ type: AGENTS_ADD_BLACKLIST + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data)

		if (data.success) {
            dispatch({type: AGENTS_ADD_BLACKLIST + SUCCESS})
        }
        if (data.error) {
            dispatch({ 
                type: AGENTS_ADD_BLACKLIST + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const deleteAgentBlackList = (params) => async (dispatch) => {

	dispatch({ type: AGENTS_DELETE_BLACKLIST + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data)

		if (data.success) {
            dispatch({ type: AGENTS_DELETE_BLACKLIST + SUCCESS })
        }
        if (data.error) {
            dispatch({ 
                type: AGENTS_DELETE_BLACKLIST + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const changeAgentAccessRights = (params) => async (dispatch) => {

	dispatch({ type: AGENTS_CHANGE_ACCESS + START })
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
        //console.log(data)

		if (data.success) {
            if (data.content) {
                dispatch({ type: AGENTS_CHANGE_ACCESS + SUCCESS })
            } else {
                dispatch({ 
                    type: AGENTS_CHANGE_ACCESS + ERROR,
                    error: 'Ошибка'
                })
            }
        }
        if (data.error) {
            dispatch({ 
                type: AGENTS_CHANGE_ACCESS + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}

export const closeErrorMsg = () => dispatch => dispatch({ type: ERRORMSG + CLOSE })


export const resetStore = () => async (dispatch) => dispatch({ type: RESET })